<div class="container position-absolute">
    <app-table [data]="sealCanceled$ | async" [columns]="columns" [pageData]="sealCanceledPage$ | async"  [search]="true" [forChangeHistory]="true" (pageEvent)="getPage($event)" (searchEvent)="search($event)" [noAdd]="true" [isDeletable]="false" [isEditable]="false"></app-table>
</div>
<!-- <router-outlet></router-outlet> -->
